import { ProjectData } from '../pages/Project/types';
import { getHexValue } from './getHexValue';

export const getUpdatedProjectData = (projectData: Array<ProjectData>) =>
  projectData.map(item => ({
    ...item,
    listenAddress: getHexValue(item.listenAddress)
  }));
